import { TExperimentsState } from '../../types/experiments';

export function isAbUseExperimentActive(experiments: TExperimentsState, experimentName: string, targetGroup: string) {
  return experiments[experimentName] === targetGroup;
}
